// Module
var code = "<template show.bind=\"roleCheckPassed\">\n  <slot></slot>\n</template>\n";
// Exports
export default code;